import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

// authors/fetchAuthors is an action type prefix and is used
// internally with pending, fulfilled, rejected
// each of these createAsyncThunks return promises
export const fetchAuthors = createAsyncThunk(
  "authors/fetchAuthors",
  async () => {
    console.log("calling GET authors...");
    const response = await axios.get(`${BASE_URL}/api/authors`);
    console.log("GET authors response: ", response);
    return response.data;
  }
);

const authorSlice = createSlice({
  name: "authors",
  initialState: {
    authors: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // fetch authors
      .addCase(fetchAuthors.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAuthors.fulfilled, (state, action) => {
        state.authors = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchAuthors.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default authorSlice.reducer;
